export const inputGroupCodes: Record<number, string> = {
  11: 'fertilizer',
  12: 'pesticide',
  13: 'seeds',
  14: 'agriWorks',
  15: 'machinery',
  16: 'equipment',
  17: 'farmWater',
};

export const inputGroupNameToCode: Record<string, number> = {
  fertilizer: 11,
  pesticide: 12,
  seeds: 13,
  agriWorks: 14,
  machinery: 15,
  equipment: 16,
  farmWater: 17,
};

export enum InputGroupCodes {
  FertilizerCode = 11,
  PesticideCode = 12,
  SeedsCode = 13,
  AgriWorkCode = 14,
  MachineryCode = 15,
  EquipmentCode = 16,
  FarmWaterCode = 17,
}
